<template>
    <div class="qd-register">
        <header class="head-nav">
            <p>Registration</p>
        </header>
        <div class="container">
            <div class="row">
                <div class="event-info">
                    <div class="title">
                        <p>{{baseInfo ? baseInfo.eventName : ''}}</p>
                        <div class="desc-content"></div>
                    </div>
                    <div class="event-list">
                        <ul :class="{'active':moreBtn}">
                            <li>
                                <label>Date:</label>
                                <p>{{baseInfo ? baseInfo.trainingDate : ''}}</p>
                            </li>
                            <li>
                                <label>Time:</label>
                                <p>{{baseInfo ? baseInfo.trainingTime : ''}}</p>
                            </li>
                            <li>
                                <label>Trainer Name:</label>
                                <p>{{baseInfo ? baseInfo.trainerName : ''}}</p>
                            </li>
                            <li>
                                <label>Speaker Name:</label>
                                <p>{{baseInfo ? baseInfo.speakerName : ''}}</p>
                            </li>
                            <li>
                                <label>Type of Training:</label>
                                <p>{{baseInfo ? baseInfo.trainingType : ''}}</p>
                            </li>
                            <li class="details" :class="{'active':online}">
                                <label>Venue Details:</label>
                                <p>{{venueDetails}}</p>
                            </li>
                        </ul>
                        <div class="more-btn" :class="{'active':moreBtn}">
                            <div class="btn-sm" @click="chooseBtn()">
                                <label>{{info}}</label>
                                <img src="" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row main-reg">
                <div class="validation-label" style="margin-top: 20px;">Please Select Mobile number OR ABO/PC ID for Registration</div>
                <div class="validation-msg selectMode">
                    <label><input type="radio" value="id" v-model="registerBy">&nbsp; ABO/PC ID</label>
                    <label><input type="radio" value="mobile" v-model="registerBy">&nbsp; Mobile Number</label>
                </div>

                <div class="validation-label">{{ inputLabel }}</div>
                <div class="validation-msg" v-if="registerBy === 'id'">
                    <input 
                        type="text" 
                        :placeholder="inputPlaceholder" 
                        v-model="value" 
                        maxlength="11" 
                    >
                </div>
                <div class="validation-msg" v-else>
                    <div class="phone-input" style="width: 100%; display:flex; align-items:center;">
                        <span class="country-code">{{ countryCode }}</span>
                        <input 
                            type="tel" 
                            :placeholder="inputPlaceholder" 
                            v-model="value" 
                        >
                    </div>
                </div>
                 <div class="error-msg" v-if="inputTypeError">
                    <label>*</label>
                    <p>{{inputTypeErrorMsg}}</p>
                </div>
                <template v-if="showExtraFields">
                    <div class="validation-label">Please select the person attending the session.</div>
                    <div class="validation-msg selectMode">
                        <label><input type="radio" value="Primary Applicant" v-model="selectedParty">&nbsp; Primary Applicant</label>
                        <label><input type="radio" value="Co-applicant" v-model="selectedParty">&nbsp; Co-applicant</label>
                    </div>
                    <div class="error-msg" v-if="error && errorMsg">
                        <label>*</label>
                        <p>{{errorMsg}}</p>
                    </div>
                </template>
                <!-- <div class="validation-msg" :class="{'active':error}">
                    <input type="text" placeholder="Please enter ADS/PC/ADR ID" v-model="value" maxlength="11" oninput = "value = value.replace(/[^0-9]+/g, '')" pattern="[0-9]">
                </div> -->
                <template v-if="showExtraFields">
                    <div class="validation-label">Please enter number of Guests NOT registered as ABO or PC.</div>
                    <div class="validation-msg" :class="{'active': error}">
                        <input 
                            type="number" 
                            placeholder="Please enter number of Guests NOT registered as ABO or PC." 
                            v-model.number="guestCount" 
                            max="11" 
                            @input="validateGuestCount"
                        >
                    </div>
                    <div class="error-msg" v-if="guestError">
                        <label>*</label>
                        <p>{{guestErrorMsg}}</p>
                    </div>
                </template>
                <div class="validation-code">
                
                </div>
                <input id="recToken" type="text" name="token" class="none">
                <div class="register-btn" :class="{'active': !showExtraFields || success}">
                    <button :disabled="isActionDisabled" class="btn" @click="onActionClick">{{ actionLabel }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
   import axios from 'axios'
   import utils from '../assets/js/utils'
   import debounce from 'lodash.debounce';
   

   export default {
    components: {
    },
      data(){
         return{
            isable:true,
            error:false,
            errorMsg:'',
            moreBtn:false,
            info:'More',
            value:'',
            derivedAboNo: '',
            registerBy: 'id',
            countryCode: '+91',
            guestCount:0,
            success:false,
            baseInfo:[],
            venueDetails:'',
            eventID:'',//活动id
            arrayLength:[],//cookies
            online:false,//是否online meeting
            url:'',//online meeting url
            partyList: [],
            selectedParty: null,
            guestError: false,
            guestErrorMsg: '',
            aboMobile: '',
            aboCountryCode: 'india', 
            aboNo: '',
            inputTypeError: false,
            inputTypeErrorMsg: '',
            showExtraFields: false,
            validatedInput: '',
         }
      },
      created(){
          if (utils.GetQueryString('EventID')) {
              this.eventID = utils.GetQueryString('EventID');
              if (this.$cookies.get("array") && JSON.parse(this.$cookies.get("array")).length > 0 && this.$cookies.get('user_session')) {
                  let arrayLen = JSON.parse(this.$cookies.get("array"));
                  for (let i = 0; i < arrayLen.length; i++) {
                      if (this.eventID == arrayLen[i].eventId) {
                          this.$router.push({
                              name: "eventSignin",
                              query: {type: 'overdue', onlinetype: arrayLen[i].online, url: arrayLen[i].url}
                          })
                          break
                      } else {
                          if (this.$cookies.get('user_session')) {
                              this.getDetailList(utils.GetQueryString('EventID'))
                              break
                          } else {
                              this.getJstoken()
                              break
                          }
                      }
                  }
              } else {
                  if (this.$cookies.get('user_session')) {
                  this.getDetailList(utils.GetQueryString('EventID'))
               }else{
                  this.getJstoken()
               }
            }
            this.loadScript('https://www.recaptcha.net/recaptcha/api.js?hl=en&render=6LeppNEUAAAAAKGkCeo47V6hVpAzP-ebCSTNhJjs',()=>{
                this.grecaptchafn()
            })
         }else{
            this.$router.push({name:"eventSignin",query:{type:'exist'}})//æ´»åŠ¨ä¸å­˜åœ¨
         }
      },
      watch:{
         registerBy(newVal, oldVal){
            this.value = '';
            this.derivedAboNo = '';
            this.selectedParty = null;
            this.error = false;
            this.errorMsg = '';
            this.success = false;
            this.isable = true;
            this.showExtraFields = false;
            this.inputTypeError = false;
            this.inputTypeErrorMsg = '';
            this.guestCount = 0;
            this.guestError = false;
         },
         // On-change: enforce 10+ digits for mobile; if user edits after Next passed, revert to Step 1
         value(newVal) {
            const raw = (newVal || '');
            const digits = raw.replace(/\D/g, '');
            if (this.registerBy === 'mobile') {
                if (digits.length > 0 && digits.length < 10) {
                    this.inputTypeError = true;
                    this.inputTypeErrorMsg = 'Mobile number must be at least 10 digits.';
                } else {
                    this.inputTypeError = false;
                    this.inputTypeErrorMsg = '';
                }
            }
            if (this.showExtraFields) {
                const normalized = this.registerBy === 'mobile' ? digits : raw.trim();
                if (this.validatedInput && normalized !== this.validatedInput) {
                    this.resetToStep1();
                } else {
                    this.checkRegisterButtonAvailable();
                }
            }
         },
         selectedParty(newValue) {
            if (newValue) {
                this.error = false; // Clear the error when a value is selected
                this.errorMsg = '';
                if(newValue){
                    this.checkRegisterButtonAvailable();
                }
            }
        },
        guestCount(newValue) {
            if (newValue || newValue === 0) {
                if(newValue > 99 || newValue < 0) {
                    this.guestError = true; // Clear the error when a value is selected
                    this.guestErrorMsg = 'Guest Count must be within 0 ~ 99';
                } else {
                    this.guestError = false; // Clear the error when a value is selected
                    this.guestErrorMsg = '';
                }

                if (newValue || newValue === 0){
                    this.checkRegisterButtonAvailable();
                }
            }
        }
      },
      computed: {
        inputLabel(){
            return this.registerBy === 'mobile' ? 'Please enter your Mobile Number' : 'Please enter your ABO/PC ID.'
        },
        inputPlaceholder(){
            return this.registerBy === 'mobile' ? 'Please enter your Mobile Number' : 'Please enter your ABO/PC ID'
        },
        actionLabel(){
            return this.showExtraFields ? 'REGISTER' : 'Next'
        },
        isActionDisabled(){
            // Next button is always active as per requirement
            if (!this.showExtraFields) return false;
            // In step 2, use existing disabled state
            return this.isable;
        }
      },
       mounted(){
          window.onload = function(){
              let ongoing = window.utag_data;
              window.utag.view(ongoing);
          }
       },
      methods:{
        async onActionClick(){
            if (!this.showExtraFields) {
                await this.handleNext();
            } else {
                this.regBtn();
            }
        },
        async handleNext(){
            this.inputTypeError = false;
            this.inputTypeErrorMsg = '';
            const val = (this.value || '').trim();
            if (!val) {
                this.inputTypeError = true;
                this.inputTypeErrorMsg = this.registerBy === 'mobile' ? 'Please enter your Mobile Number.' : 'Please enter your ABO/PC ID.';
                return;
            }
            if (this.registerBy === 'mobile'){
                const digits = val.replace(/\D/g, '');
                if (digits.length < 10){
                    this.inputTypeError = true;
                    this.inputTypeErrorMsg = 'Mobile number must be at least 10 digits.';
                    return;
                }
                const ok = await this.validatePhoneNumber();
                if (!ok) return;
                this.validatedInput = digits;
            } else {
                const ok = await this.validateAboNumber();
                if (!ok) return;
                this.validatedInput = val;
            }
            // Passed validation -> expand remaining fields
            this.showExtraFields = true;
            this.selectedParty = 'Primary Applicant';
            if (this.guestCount === null || this.guestCount === undefined) this.guestCount = 0;
            this.checkRegisterButtonAvailable();
        },
        resetToStep1(){
            this.showExtraFields = false;
            this.selectedParty = null;
            this.guestCount = 0;
            this.guestError = false;
            this.guestErrorMsg = '';
            this.success = false;
            this.isable = true;
            this.error = false;
            this.errorMsg = '';
            this.validatedInput = '';
            this.aboNo = '';
            this.aboMobile = '';
        },
        checkRegisterButtonAvailable() {
            let hasValidInput = false;
            if (this.registerBy === 'mobile') {
                const digits = (this.value || '').replace(/\D/g, '');
                hasValidInput = digits.length >= 10 && !this.inputTypeError;
            } else {
                hasValidInput = !!this.value && this.value.length > 0;
            }

            if (hasValidInput && this.selectedParty && this.guestCount >= 0 && this.guestCount < 100) {
                this.success = true;
                this.isable = false;
            } else {
                this.success = false;
                this.isable = true;
            }
        },
         getJstoken () {
            axios.defaults.timeout = 60000
            return new Promise((resolve, reject) => {
               axios.get(process.env.VUE_APP_TOKEN + '/exchangjstoken/ac84bea68d759db0b32d7908e1ebbff7').then((res) => {
                  if(res.data.jstoken){
                     this.$cookies.set("user_session",res.data.jstoken,60 * 60 * 1)
                     this.getDetailList(utils.GetQueryString('EventID'))
                  }
                  resolve(res)
               }) .catch(error => {
                  reject(error);
               });
            })
         },
         validateGuestCount(event) {
            // Allow only numbers and ensure the value is an integer
            const value = event.target.value.replace(/[^0-9]/g, ''); 
            this.guestCount = value ? parseInt(value, 10) : null;

            // Optional: Error handling logic (e.g., prevent exceeding max guests)
            if (this.guestCount > 99) { // Example limit check
                    this.error = true;
                } else {
                    this.error = false;
                }
        },
        
          //获取活动信息
         // trainingStatus  1 = 没过期  0 = 过期failed  3 = 取消cancel 4 = 关闭close 5=没开始notStart
         getDetailList (id) {
            let params = {
               EventID: id
            }
            this.showloading('Loading')
            this.axios.getDetailInfo(params).then(res => {
               this.hideloading()
               if(res.resultCode==1){
                  this.baseInfo = res
                  this.url= res.venueDetails;
                   if(res.venueType=='Online' || res.venueType=='ONLINE'){
                       this.venueDetails = 'Online meeting'
                       this.online = true
                   }else{
                       this.venueDetails = res.venueDetails
                   }
                  window.sessionStorage.setItem('eventData',JSON.stringify(res))
                  if(res.trainingStatus==0){
                     this.$router.push({name:"eventSignin",query:{type:'failed'}})//活动已结束/过期 (活动状态不是完成/取消)
                  }else if(res.trainingStatus==2){
                     this.$router.push({name:"eventSignin",query:{type:'cancel'}})//活动已取消
                  }else if(res.trainingStatus==3){
                     this.$router.push({name:"eventSignin",query:{type:'close'}})//活动已关闭
                  }else if(res.trainingStatus==4){
                     this.$router.push({name:"eventSignin",query:{type:'notStart'}})//活动没开始
                  } else {
                     if(this.$cookies.get("array") && JSON.parse(this.$cookies.get("array")).length>0){
                        let arrayLen = JSON.parse(this.$cookies.get("array"));
                        arrayLen.forEach(item=>{
                           if(this.eventID==item.eventId){
                              this.$router.push({name:"eventSignin",query:{type:'overdue',onlinetype:item.online,url:item.url}})
                           }else{
                              this.signinTrain(item.userId,this.eventID)
                           }
                        })
                     }
                  }
               }else if(res.resultCode==2){
                  this.$router.push({name:"eventSignin",query:{type:'exist'}})//活动不存在
               }else{
                  this.dialogmsg(res.resultMsg)
               }
            })
         },
         //校验ADS是否已成功签到过
         signinTrain(ada,id){
            let params = {
               EventID: id,
               ADANo:ada
            };
            this.axios.ValidateTrain(params).then(res =>{
               this.hideloading()
               if(res.resultCode==2){
                  this.$router.push({name:"eventSignin",query:{type:'overdue',onlinetype:this.online,url:this.url}})
               }
            })
         },
          //动态加载script
         loadScript(url,callback){
            var script=document.createElement('script');
            script.type='text/javascript';
            script.async='async';
            script.src=url;
            document.body.appendChild(script);
            if(script.readyState){   //IE
               script.onreadystatechange=function(){
                  if(script.readyState=='complete'||script.readyState=='loaded'){
                     script.onreadystatechange=null;
                     callback();
                  }
               }
            }else{    //非IE
               script.onload=function(){callback();}
            }
         },
         grecaptchafn(){
            grecaptcha.ready(function() {
               var renderKey = '6LeppNEUAAAAAKGkCeo47V6hVpAzP-ebCSTNhJjs'
               grecaptcha.execute(renderKey, {action: '/'}).then(function(token) {
                  document.getElementById('recToken').value = token;
               });
            });
         },
         //发现更多
         chooseBtn(){
            this.moreBtn = !this.moreBtn;
            this.info = this.moreBtn ? 'Collapse' : 'More'
         },
         //签到
         regBtn(){
            console.log(`Guest Count: ${this.guestCount} `);
            if(this.value==''){
               this.inputTypeError = true;
               this.inputTypeErrorMsg = this.registerBy === 'mobile' ? 'Please enter your Mobile Number.' : 'Please enter ADS/PC/ADR ID.';
               return
            }else if (!this.selectedParty) {
                this.error = true;
                this.errorMsg = 'Please select the person attending the session.';
                return;
            } else if (this.guestCount > 99 || this.guestCount < 0) {
                this.guestError = true;
                this.guestErrorMsg = 'Please Guest Count must be insert or between 0 ~ 99 only.';
                return;
            }else{
                console.log(this.selectedParty)
               if(this.$cookies.get("array") && JSON.parse(this.$cookies.get("array")).length>0 && this.$cookies.get('user_session') ){
                  let arrayLen = JSON.parse(this.$cookies.get("array"));
                  for(let i=0;i<arrayLen.length;i++){
                     if(this.eventID==arrayLen[i].eventId){
                        this.$router.push({name:"eventSignin",query:{type:'overdue',onlinetype:this.online,url:this.url}})
                        break
                     }
                  }
                  this.isable = true
                  let token = document.getElementById('recToken').value;
                  let ip = "";
                  this.checktoken(token,ip)
               }else{
                  this.isable = true
                  let token = document.getElementById('recToken').value;
                  let ip = "";
                  this.error = false;
                  this.errorMsg = '';
                  this.inputTypeErrorMsg = '';
                  this.inputTypeError = false;
                  this.checktoken(token,ip) 
               }
            }
         },
         //校验recaptcha--v3
         checktoken(token,ip){
            let params = {
               'secret':'6LeppNEUAAAAAG5Vn0XYFB82NMma4Sof6D5SDu-Q',
               'response':token,
               'remoteip':ip
            }
            this.showloading('Loading')
            this.isable = false
            this.axios.checkAccsstoken(params).then(res =>{
               this.grecaptchafn()
               if(res.success){
                  this.robotVerified()
               }else{
                  this.hideloading()
                  this.dialogmsg("Connection timeout, please click OK to reconnect!")
               }
            })
         },
         //校验 ADA是否存在、已重复签到、活动是否已过期
         robotVerified(){
            let params = {
               EventID: this.eventID,
               ADANo: this.getADANumber()
            }
            this.axios.ValidateTrain(params).then(res =>{
               if(res.resultCode==1){
                  this.register()
               }else if(res.resultCode==2) {
                   let flag = false;
                   if(this.$cookies.get("array") && res.resultCode==2){
                       let arrayLen = JSON.parse(this.$cookies.get("array"));
                       for (let i = 0; i < arrayLen.length; i++) {
                           if (this.eventID == arrayLen[i].eventId) {
                               flag = false
                               break
                           }
                       }
                   } else {
                       flag = true
                   }
                   this.$router.push({
                       name: "eventSignin",
                       query: {type: 'overdue', onlinetype: this.online, isClear: flag, url: this.url}
                   })
               } else {
                   let ongoing = window.utag_data;
                   window.utag_data['search_keyword'] = this.value
                   window.utag_data['page_name'] = "Account ID is inactive"
                   window.utag.view(ongoing);
                   this.hideloading()
                   this.dialogmsg(res.errorMessage || res.resultMsg || res.errorCode)
               }
            })
         },

        onValueFinished() {
            this.value = this.value.trim();
            if (this.value.length > 0) {
                if(this.registerBy === 'mobile'){
                    // Pre-validate: mobile must be at least 10 digits
                    const digits = this.value.replace(/\D/g, '');
                    if (digits.length < 10) {
                        this.inputTypeError = true;
                        this.inputTypeErrorMsg = 'Mobile number must be at least 10 digits.';
                        this.success = false;
                        this.isable = true;
                        return; // Do not call API
                    }
                    this.validatePhoneNumber();
                }else{
                    this.validateAboNumber();
                }
            } else {
                // If the input is empty, clear the party list and disable the button
                this.selectedParty = null;
                this.isable = true;
            }
        },

        async validatePhoneNumber(){
            try{
                this.showloading('Loading');
                const digits = (this.value || '').replace(/\D/g, '');
                if (digits.length < 10) {
                    this.hideloading();
                    this.inputTypeError = true;
                    this.inputTypeErrorMsg = 'Mobile number must be at least 10 digits.';
                    this.success = false;
                    this.isable = true;
                    return false;
                }
                const params = {
                    phoneCountryCode: this.countryCode,
                    phoneNumber: this.value
                };
                const res = await this.axios.ValidatePhoneNumber(params);
                this.hideloading();
                if(res.resultCode === "1" || res.resultCode === 1){
                    if(res.isValid === false){
                        this.success = false;
                        this.isable = true;
                        this.value = '';
                        this.dialogmsg('Invalid mobile number');
                        return false;
                    }
                    this.aboMobile = res.aboMobile;
                    return true;
                }else{
                    this.derivedAboNo = '';
                    this.success = false;
                    this.isable = true;
                    this.value = '';
                    this.dialogmsg(res.errorMsg || 'Error validating mobile number');
                    return false;
                }
            }catch(e){
                this.hideloading();
                this.derivedAboNo = '';
                this.success = false;
                this.isable = true;
                this.value = '';
                this.dialogmsg('Failed to validate mobile number');
                return false;
            }
        },

        async validateAboNumber(){
            try{
                this.showloading('Loading');
                const params = {
                    aboNo: this.value,
                    countryCode: this.aboCountryCode
                };
                const res = await this.axios.ValidateAboNumber(params);
                this.hideloading();
                if(res.resultCode === "1" || res.resultCode === 1){
                    if(res.isValid === false){
                        this.success = false;
                        this.isable = true;
                        this.value = '';
                        this.dialogmsg('Invalid abo number');
                        return false;
                    }
                    this.aboNo = res.aboNum;
                    return true;
                }else{
                    this.derivedAboNo = '';
                    this.success = false;
                    this.isable = true;
                    this.value = '';
                    this.dialogmsg(res.errorMsg || 'Error validating abo number');
                    return false;
                }
            }catch(e){
                this.hideloading();
                this.derivedAboNo = '';
                this.success = false;
                this.isable = true;
                this.value = '';
                this.dialogmsg('Failed to validate abo number');
                return false;
            }
        },

         //签到
        register(){
            console.log(this.guestCount)
            /*
            {
                "EventID":"F25012365920",
                "ADANo":"+916000119280",
                "GuestCount":1, 
                "AccountName":"Primary Applicant", 
                "RegisterType":"mobile"
            }
            */
            let params = {
               EventID: this.eventID,
               ADANo:this.registerBy === 'mobile' ? this.aboMobile : this.aboNo,
               GuestCount:this.guestCount,
               AccountName: this.selectedParty,
               RegisterType: this.registerBy,

            }
            this.axios.NewRegisterTrain(params).then(res =>{
               this.hideloading()
               if(res.resultCode==1){
                  if(res.validationStatus==1){
                     this.$router.push({name:"eventSignin",query:{type:'cancel'}})//活动已取消
                  }else if(res.validationStatus==2){
                     this.$router.push({name:"eventSignin",query:{type:'close'}})//活动已关闭
                  }else if(res.validationStatus==3){
                     this.$router.push({name:"eventSignin",query:{type:'notStart'}})//活动没开始
                  }else if (res.validationStatus == 4) {
                      this.$router.push({name: "eventSignin", query: {type: 'failed'}})//活动已结束/过期 (活动状态不是完成/取消)
                  } else if (res.validationStatus == 5) {
                      let ongoing = window.utag_data;
                      window.utag_data['search_keyword'] = this.value
                      window.utag_data['page_name'] = "You have already registered for the activity"
                      window.utag.view(ongoing);
                      let flag = false;
                      if (this.$cookies.get("array")) {
                          let arrayLen = JSON.parse(this.$cookies.get("array"));
                          for (let i = 0; i < arrayLen.length; i++) {
                              if (this.eventID == arrayLen[i].eventId) {
                                  flag = false
                                  break
                              }
                          }
                      } else {
                          flag = true
                      }
                      this.$router.push({
                          name: "eventSignin",
                          query: {type: 'overdue', onlinetype: this.online, isClear: flag, url: this.url}
                      })
                  } else if (res.validationStatus == 6) {
                      this.$router.push({name: "eventSignin", query: {type: 'limit'}})//活动表示注册人数超过了限制。
                  }else if (res.validationStatus == 7) {
                      this.dialogmsg('Sorry, you\'re not invited to join this training.')
                  } else {
                      let ongoing = window.utag_data;
                      window.utag_data['search_keyword'] = this.value
                      window.utag_data['page_name'] = "Thank you for your registration"
                      window.utag.view(ongoing);
                      if (this.$cookies.get("array") && JSON.parse(this.$cookies.get("array")).length > 0) {
                          let arrayLen = JSON.parse(this.$cookies.get("array"));
                          let data = []
                          data.push({
                              eventId: this.eventID,
                              userId: this.value,
                              online: this.online,
                              url: this.url,
                              date: new Date()
                          })
                          let array = arrayLen.concat(data)
                          this.arrayLength = array
                      } else {
                          let data = []
                          data.push({
                              eventId: this.eventID,
                              userId: this.value,
                              online: this.online,
                              url: this.url,
                              date: new Date()
                          })
                          this.arrayLength = data
                      }

                       //this.$cookies.set("array", JSON.stringify(this.arrayLength), 60 * 60 * 24)// 以秒为单位，设置1天过去
                      this.$cookies.set("array", JSON.stringify(this.arrayLength), 60 * 60 * 8)// 以秒为单位，change to 8 hours
                      //succeed签到成功
                      this.$router.push({
                          name: "eventSignin",
                          query: {type: 'succeed', onlinetype: this.online, url: this.url}
                      })
                  }
               }else if(res.resultCode==0){
                  //this.error = true;
                  //this.errorMsg =  res.errorCode;
                  this.derivedAboNo = '';
                  this.success = false;
                  this.isable = true;
                  this.value = '';
                  this.dialogmsg(res.errorCode)
               }else{
                  this.dialogmsg(res.errorCode)
               }
            })
         },
         // Helper: return ADANo based on current mode
         getADANumber(){
            return this.registerBy === 'mobile' ? this.derivedAboNo : this.value;
         },
         dialogmsg(msg){
            this.$dialog.alert({
               title: 'Error',
               message: msg,
               confirmButtonText:'OK',
            }).then((action) => {
               if(action=='confirm'){
                  this.grecaptchafn()
               }
            })
         }
      }
   }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .qd-register{
        .head-nav{
            background-color: #002F5F;
            text-align: center;
            line-height: 45px;
            height: 45px;
            p{
                font-size: 18px;
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
            }
        }
        .main-reg{
            margin-top: 10px;
            background-color: white;
            .error-msg{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                margin: 12px 37px 0px;
                label{
                    font-size: 14px;
                    color: #FF2A2A;
                    letter-spacing: 0;
                    margin-right: 5px;
                }
                p{
                    line-height: 20px;
                    font-size: 14px;
                    color: #FF2A2A;
                    letter-spacing: 0;
                    text-align: left;
                }
            }
            .none{
                display: none;
            }
        }
        .row{
            border: 1px solid #E3E3E3;
            .event-img{
                height: 151px;
                width: 100%;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .event-info{
                background: white;
                .title{
                    font-size: 18px;
                    color: #002F5F;
                    letter-spacing: 0;
                    padding: 12px 22px 10px;
                    text-align: left;
                    font-family: PingFangSC-Medium;
                }
                .desc-content{
                    width: 20px;
                    height: 5px;
                    background: #ED174C;
                    margin-top: 6.5px;
                }
                .event-list{
                    padding: 11px 22px;
                    ul.active{
                        height: auto;
                    }
                    ul{
                        border-bottom: 1px solid #E3E3E3;
                        height: 53px;
                        overflow: hidden;
                        padding-bottom: 9px;
                        li.details{
                            flex-direction: column;
                            p{
                                text-align: left;
                                margin-left: 0px;
                                margin-top: 10px;
                            }
                        }
                        li.details.active{
                            flex-direction: row;
                            p{
                                text-align: right;
                                margin-left: 0px;
                                margin-top: 0px;
                            }
                        }
                        li{
                            display: flex;
                            flex-direction: row;
                            align-items: self-end;
                            margin-bottom: 10px;
                            label{
                                display:block;
                                text-align: left;
                                font-size: 14px;
                                color: #929292;
                                letter-spacing: 0;
                                line-height: 20px;
                                min-width: 105px;
                                font-family: PingFangSC-Medium;
                            }
                            p{
                                font-size: 14px;
                                color: #1A1A1A;
                                letter-spacing: 0;
                                line-height: 20px;
                                margin-left: 15px;
                                text-align: right;
                                flex: 1;
                                font-family: PingFangTC-Regular;
                            }
                        }
                    }
                }
                .more-btn.active{
                    .btn-sm{
                        width: 107px;
                        img{
                            width: 0;
                            height: 0;
                            border-top:0px solid transparent;
                            border-bottom: 7px solid #002F5F;
                            border-right: 5px solid transparent;
                            border-left: 5px solid transparent;
                        }
                    }
                }
                .more-btn{
                    margin-top: 19px;
                    .btn-sm{
                        width: 74px;
                        margin: auto;
                        font-family: PingFangTC-Regular;
                        label{
                            font-size: 15px;
                            color: #002F5F;
                            letter-spacing: 0;
                            margin-right: 11px;
                        }
                        img{
                            width: 0;
                            height: 0;
                            border-left: 5px solid transparent;
                            border-right: 5px solid transparent;
                            border-top: 7px solid #002F5F;
                            border-bottom: 0px solid #002F5F;
                        }
                    }
                }
            }
            .validation-label{
                text-align: left;
                justify-content: left;
                align-items: left;
                display: flex;
                margin: 10px 37px 8px;
                font-weight: bold
            }
            .validation-msg.active{
                border:1px solid rgba(237,23,76,1);
                margin-top: 7px;
            }
            .validation-msg{
                text-align: center;
                justify-content: center;
                align-items: center;
                display: flex;
                margin: 10px 37px 22px;
                border: 1px solid rgba(227,227,227,1);
                input{
                    height: 40px;
                    width: 100%;
                    border-radius: 1px;
                    line-height: 40px;
                    padding-left: 12px;
                    border:none;
                    font-size: 15px;
                    font-family: PingFangTC-Regular;
                }
                input::-webkit-input-placeholder {
                    color: rgba(146,146,146,1);
                }
                input::-moz-input-placeholder {
                    color: rgba(146,146,146,1);
                }
                input::-ms-input-placeholder {
                    color: rgba(146,146,146,1);
                }
                .phone-input{
                    width: 100%;
                    display: flex;
                    align-items: center;
                }
                .country-code{
                    padding: 0 8px;
                    color: #333;
                    white-space: nowrap;
                }
            }
            /* Make the registration mode radios vertical and smaller */
            .validation-msg.selectMode{
                border: 0;
                display: block;
                text-align: left;
                margin: 0 37px 20px;
            }
            .validation-msg.selectMode label{
                display: flex;
                align-items: center;
                margin: 6px 0;
            }
            .validation-msg.selectMode input[type='radio']{
                width: 16px;
                height: 16px;
                margin-right: 8px;
                transform: scale(0.85);
            }
            .validation-code{
                margin: auto;
                .g-recaptcha{
                    display: flex;
                    justify-content: center;
                }
                .g-recaptcha>div{
                    width: 50px!important;
                }
                .rc-anchor-content{
                    width: 100px!important;
                }
            }
            .register-btn{
                height: 48px;
                line-height: 48px;
                margin: 20px 37px 29px;
                button{
                    background: #AEAEAE;
                    border-radius: 6px;
                    border-width: 0;
                    font-size: 15px;
                    color: #FFFFFF;
                    letter-spacing: 0;
                    text-align: center;
                    width: 100%;
                    padding: 0;
                    font-family: PingFangSC-Medium;
                }
            }
            .register-btn.active{
                button{
                    background: #002F5F;
                    border-radius: 6px;
                }
            }
        }
    }
    @media screen and (min-width: 438px) {
        .qd-register .row .event-info .event-list ul{
            height: 53px;
        }
    }
</style>
